import React, { useContext } from "react";
import { Image, View } from "react-native";
import Icon from "react-native-vector-icons/Ionicons";
import { useColorScheme } from "react-native-appearance";
import { colors } from "../context/Colors";
import AppContext from "../context";

export default function InventoryObjectThumb({ o }) {
  const theme = useColorScheme() === "dark" ? "dark" : "light";
  const { resolveURL } = useContext(AppContext);

  if (o.objectType === "Object" || o.objectType === "Puzzle")
    return (
      <View
        style={{
          width: 60,
          height: 60,
          backgroundColor: colors[theme].buttonBorder,
          borderRadius: 8,
        }}
      >
        <Image
          source={{
            uri: resolveURL("game", o.objectBlobReference, 120),
          }}
          style={{
            width: 50,
            height: 50,
            marginRight: 10,
            borderRadius: 8,
            margin: 5,
          }}
          resizeMode={"contain"}
        />
      </View>
    );
  if (o.objectType === "Text")
    return (
      <View
        style={{
          width: 60,
          height: 60,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Image
          source={require("../assets/message.png")}
          style={{ width: 56, height: 57 }}
        />
      </View>
    );

  if (o.objectType === "Audio")
    return (
      <View
        style={{
          width: 60,
          height: 60,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Image
          source={require("../assets/audio.png")}
          style={{ width: 67, height: 58 }}
        />
      </View>
    );

  if (o.objectType === "Letter")
    return (
      <Image
        source={{
          uri: "https://studio.guidigo.com/Image/Letter/?id=" + o.objectName,
        }}
        style={{ width: 60, height: 60 }}
      />
    );

  return (
    <View
      style={{
        width: 60,
        height: 60,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: colors[theme].buttonBorder,
        borderRadius: 8,
      }}
    />
  );
}
